import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-paper-dialog',
  templateUrl: './paper-dialog.component.html',
  styleUrls: ['./paper-dialog.component.scss']
})
export class PaperDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<PaperDialogComponent>
  ) { }

  public onClose(value: boolean): void {
    this.dialogRef.close(value);
  }
}
